module.exports = __webpack_public_path__ + "img/p26.59de54ac.svg";